import React from 'react';
import { Popconfirm, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllTabs } from '@store/common/actions';
import { Item } from 'react-contexify';
import { getActiveTabId } from '@store/common/selectors';
import { globalRouter } from '@src/utils/globalRouter';
import { useDefaultLandingPageStore, getDefaultPath } from '@globalStore/defaultLandingPageStore';

const FIXED_TABS = ['trends', 'noc', 'overview', 'manual_alerts', 'saved_dashboards'];

function CloseAllTabsMenuItem() {
  // Get path from Zustand store and apply the same transformation as defaultPathSelector
  const path = useDefaultLandingPageStore((state) => state.path);
  const defaultPath = getDefaultPath(path);
  const activeId = useSelector(getActiveTabId) as string;
  const dispatch = useDispatch();

  function handleClick({ event }) {
    event.stopPropagation();
  }

  function confirm() {
    dispatch(closeAllTabs());
    message.success('Closed all tabs.');
    // redirect to default path only if the user is in a temp tab
    if (!FIXED_TABS.includes(activeId)) {
      globalRouter.navigate(defaultPath);
    }
  }

  function cancel() {
    // do nothing
  }

  return (
    <Popconfirm
      title="Unsaved dashboards will not be saved. Are you sure you want to close all tabs?"
      okText="Yes"
      cancelText="No"
      onConfirm={confirm}
      onCancel={cancel}
    >
      <Item onClick={handleClick}>Close All Tabs</Item>
    </Popconfirm>
  );
}

export default CloseAllTabsMenuItem;
